import React from 'react';
import { FieldArray } from 'formik';

import { InputControl, SelectControl } from 'modules/shared-form';
import { GroupCheckboxesInputControl } from '..';

import { QuestionsControlProps } from '.';

import styles from './questions-control-component.module.css';

export const QuestionsControl: React.FC<QuestionsControlProps> = ({
    formProps,
    questions,
    name,
    ...rest
}: QuestionsControlProps) => {
    return (
        <FieldArray
            name={name}
            render={() => {
                const setQuestionIdField = (fieldName: string, id: number): void => {
                    formProps.setFieldValue(fieldName, id);
                };
                return (
                    <div className={styles.rootContainer}>
                        {questions &&
                            questions.length > 0 &&
                            questions.map((question, index) => {
                                const field = `${name}[${index}]`;
                                const questionIdName = `${field}.questionId`;
                                const answerName = `${field}.answer`;
                                const { id, text, required, maxChars } = question;

                                return (
                                    <div key={`question${id}`}>
                                        <div className={styles.label}>{`${text}${question.required ? ' *' : ''}`}</div>
                                        {
                                            {
                                                alphaNumeric: (
                                                    <div>
                                                        <div className={styles.secondaryLabel}>
                                                            Sachez que Printemps est très sensible au respect de la vie
                                                            privée des personnes. Nous vous invitons à ne pas
                                                            communiquer dans ce champ des informations trop
                                                            personnelles, et à veiller à ce qu&apos;elles soient
                                                            uniquement en lien avec l&apos;objet des présentes.
                                                        </div>
                                                        <InputControl
                                                            name={answerName}
                                                            required={required}
                                                            maxLength={maxChars}
                                                            onChange={() => setQuestionIdField(questionIdName, id)}
                                                        />
                                                    </div>
                                                ),
                                                list: (
                                                    <SelectControl
                                                        name={answerName}
                                                        required={required}
                                                        options={question.listOptions || []}
                                                        customNoSelectionOption={{
                                                            key: '',
                                                            value: '',
                                                            text: '--',
                                                        }}
                                                        onChange={() => setQuestionIdField(questionIdName, id)}
                                                    />
                                                ),
                                                multiSelectList: (
                                                    <GroupCheckboxesInputControl
                                                        name={answerName}
                                                        required={required}
                                                        options={question.multiSelectOptions || []}
                                                        onChange={() => setQuestionIdField(questionIdName, id)}
                                                    />
                                                ),
                                            }[question.controlType]
                                        }
                                    </div>
                                );
                            })}
                    </div>
                );
            }}
            {...rest}
        />
    );
};
